const b = 180 / Math.PI, N = Math.PI / 180, o = p(Array.from({ length: 256 }, (s, t) => t));
function g(s) {
  return s * s * s * (s * (s * 6 - 15) + 10);
}
function c(s, t, n) {
  const e = s & 15, i = e < 8 ? t : n, h = e < 4 ? n : e === 12 || e === 14 ? t : 0;
  return (e & 1 ? -i : i) + (e & 2 ? -h : h);
}
function T(s, t) {
  const n = Math.floor(s) & 255, e = Math.floor(t) & 255;
  s -= Math.floor(s), t -= Math.floor(t);
  const i = g(s), h = g(t), a = o[n] + e, u = o[n + 1] + e;
  return l(
    l(c(o[a], s, t), c(o[u], s - 1, t), i),
    l(c(o[a + 1], s, t - 1), c(o[u + 1], s - 1, t - 1), i),
    h
  );
}
function A(s, t, n) {
  return Math.min(Math.max(s, t), n);
}
function l(s, t, n) {
  return s + (t - s) * n;
}
function I(s, t, n) {
  return s + y(t, s) * n;
}
function y(s, t) {
  return (t - s + 180) % 360 - 180;
}
function m(s, t) {
  return s + Math.random() * (t - s);
}
function f(s, t) {
  return Math.floor(m(s, t));
}
function D(s) {
  return s[f(0, s.length)];
}
function w() {
  return Math.random() < 0.5;
}
function P() {
  return w() ? 1 : -1;
}
function p(s) {
  const t = s.slice();
  for (let n = t.length - 1; n > 0; n--) {
    const e = f(0, n + 1);
    [t[n], t[e]] = [t[e], t[n]];
  }
  return t;
}
function O(s) {
  for (let t = s.length - 1; t > 0; t--) {
    const n = f(0, t + 1);
    [s[t], s[n]] = [s[n], s[t]];
  }
  return s;
}
class r {
  /**
   * Creates a new Vector2 instance.
   * @param x - The x component.
   * @param y - The y component.
   */
  constructor(t, n) {
    this.x = t, this.y = n;
  }
  /**
   * Creates a Vector2 from an object with x and y properties.
   * @param obj - The object containing x and y properties.
   * @returns A new Vector2 instance.
   */
  static fromObject(t) {
    return new r(t.x, t.y);
  }
  /**
   * Creates a Vector2 with both x and y components set to 0.
   * @returns A new Vector2 instance.
   */
  static zero() {
    return new r(0, 0);
  }
  /**
   * Creates a Vector2 with x component set to 0 and y component set to 1.
   * @returns A new Vector2 instance.
   */
  static top() {
    return new r(0, 1);
  }
  /**
   * Creates a Vector2 with x component set to 0 and y component set to -1.
   * @returns A new Vector2 instance.
   */
  static bottom() {
    return new r(0, -1);
  }
  /**
   * Creates a Vector2 with x component set to -1 and y component set to 0.
   * @returns A new Vector2 instance.
   */
  static left() {
    return new r(-1, 0);
  }
  /**
   * Creates a Vector2 with x component set to 1 and y component set to 0.
   * @returns A new Vector2 instance.
   */
  static right() {
    return new r(1, 0);
  }
  /**
   * Creates a random Vector2 on a circle with the given radius.
   * @param radius - The radius of the circle.
   * @returns A new Vector2 instance.
   */
  static randomOnCircle(t) {
    const n = Math.random() * Math.PI * 2, e = t * Math.cos(n), i = t * Math.sin(n);
    return new r(e, i);
  }
  /**
   * Creates a random Vector2 inside a circle with the given radius.
   * @param radius - The radius of the circle.
   * @returns A new Vector2 instance.
   */
  static randomInCircle(t) {
    const n = Math.sqrt(Math.random()) * t, e = Math.random() * Math.PI * 2, i = n * Math.cos(e), h = n * Math.sin(e);
    return new r(i, h);
  }
  /**
   * Creates a Vector2 from an angle in radians.
   * @param angle - The angle in radians.
   * @returns A new Vector2 instance.
   */
  static fromAngle(t) {
    return new r(Math.cos(t), Math.sin(t));
  }
  /**
   * Creates a Vector2 from an angle in degrees.
   * @param angle - The angle in degrees.
   * @returns A new Vector2 instance.
   */
  static fromAngleDeg(t) {
    return r.fromAngle(t * Math.PI / 180);
  }
  /**
   * Creates a Vector2 from a tuple of numbers representing x and y components.
   * @param tuple - The tuple containing x and y components.
   * @returns A new Vector2 instance.
   */
  static fromTuple([t, n]) {
    return new r(t, n);
  }
  /**
   * Creates a copy of the Vector2 instance.
   * @returns A new Vector2 instance with the same x and y components.
   */
  clone() {
    return new r(this.x, this.y);
  }
  /**
   * Adds another Vector2 to this Vector2.
   * @param v - The Vector2 to add.
   * @returns A new Vector2 instance representing the sum of the two vectors.
   */
  add(t) {
    return new r(this.x + t.x, this.y + t.y);
  }
  /**
   * Subtracts another Vector2 from this Vector2.
   * @param v - The Vector2 to subtract.
   * @returns A new Vector2 instance representing the difference between the two vectors.
   */
  sub(t) {
    return new r(this.x - t.x, this.y - t.y);
  }
  /**
   * Multiplies this Vector2 by another Vector2 component-wise.
   * @param v - The Vector2 to multiply.
   * @returns A new Vector2 instance representing the component-wise product of the two vectors.
   */
  mult(t) {
    return new r(this.x * t.x, this.y * t.y);
  }
  /**
   * Calculates the dot product between this Vector2 and another Vector2.
   * @param v - The Vector2 to calculate the dot product with.
   * @returns The dot product of the two vectors.
   */
  dot(t) {
    return this.x * t.x + this.y * t.y;
  }
  /**
   * Scales this Vector2 by a scalar value.
   * @param scaler - The scalar value to scale by.
   * @returns A new Vector2 instance representing the scaled vector.
   */
  scale(t) {
    return new r(this.x * t, this.y * t);
  }
  /**
   * Limits the length of this Vector2 to a specified value.
   * @param length - The maximum length of the vector.
   * @returns A new Vector2 instance with the same direction but a length no greater than the specified value.
   */
  limitLength(t = 1) {
    return this.length <= t ? this.clone() : this.asLength(t);
  }
  /**
   * Sets the length of this Vector2 to a specified value.
   * @param length - The new length of the vector.
   * @returns A new Vector2 instance with the same direction but the specified length.
   */
  asLength(t) {
    return this.normalized.scale(t);
  }
  /**
   * Gets the squared magnitude (length^2) of this Vector2.
   * @returns The squared magnitude of the vector.
   */
  get squaredMagnitude() {
    return this.x ** 2 + this.y ** 2;
  }
  /**
   * Gets the magnitude (length) of this Vector2.
   * @returns The magnitude of the vector.
   */
  get length() {
    return Math.hypot(this.x, this.y);
  }
  /**
   * Gets the normalized version of this Vector2.
   * @returns A new Vector2 instance with the same direction but a length of 1.
   */
  get normalized() {
    return new r(this.x / this.length, this.y / this.length);
  }
  /**
   * Gets the components of this Vector2 as a tuple.
   * @returns A tuple containing the x and y components of the vector.
   */
  get asTuple() {
    return [this.x, this.y];
  }
  /**
   * Gets the components of this Vector2 as an object with x and y properties.
   * @returns An object containing the x and y components of the vector.
   */
  get asObject() {
    return { x: this.x, y: this.y };
  }
  /**
   * Gets the angle (in radians) of this Vector2.
   * @returns The angle of the vector in radians.
   */
  get angle() {
    return Math.atan2(this.y, this.x);
  }
  /**
   * Gets the angle (in degrees) of this Vector2.
   * @returns The angle of the vector in degrees.
   */
  get angleDeg() {
    return this.angle * 180 / Math.PI;
  }
  /**
   * Checks if this Vector2 is equal to another Vector2.
   * @param v - The Vector2 to compare.
   * @returns True if the vectors are equal, false otherwise.
   */
  equals(t) {
    return this.x === t.x && this.y === t.y;
  }
  /**
   * Checks if this Vector2 is equal to the zero vector (0, 0).
   * @returns True if the vector is the zero vector, false otherwise.
   */
  get isZero() {
    return this.x === 0 && this.y === 0;
  }
  /**
   * Checks if this Vector2 has finite components.
   * @returns True if the vector has finite components, false otherwise.
   */
  get isFinite() {
    return Number.isFinite(this.x) && Number.isFinite(this.y);
  }
  /**
   * Checks if this Vector2 has NaN components.
   * @returns True if the vector has NaN components, false otherwise.
   */
  get isNan() {
    return Number.isNaN(this.x) || Number.isNaN(this.y);
  }
  /**
   * Negates this Vector2.
   * @returns A new Vector2 instance with the negated components.
   */
  negate() {
    return new r(-this.x, -this.y);
  }
  /**
   * Rotates this Vector2 by a specified angle (in radians).
   * @param angle - The angle to rotate by.
   * @returns A new Vector2 instance representing the rotated vector.
   */
  rotate(t) {
    const n = Math.cos(t), e = Math.sin(t), i = this.x * n - this.y * e, h = this.x * e + this.y * n;
    return new r(i, h);
  }
  /**
   * Rotates this Vector2 around a specified center point by a specified angle (in radians).
   * @param center - The center point to rotate around.
   * @param angle - The angle to rotate by.
   * @returns A new Vector2 instance representing the rotated vector.
   */
  rotateAround(t, n) {
    const e = Math.cos(n), i = Math.sin(n), h = this.x - t.x, a = this.y - t.y, u = h * e - a * i, x = h * i + a * e, d = u + t.x, M = x + t.y;
    return new r(d, M);
  }
  /**
   * Calculates the angle (in radians) between this Vector2 and another Vector2.
   * @param v - The Vector2 to calculate the angle to.
   * @returns The angle between the two vectors in radians.
   */
  angleTo(t) {
    const n = t.x - this.x, e = t.y - this.y;
    return Math.atan2(e, n);
  }
  /**
   * Calculates the distance between this Vector2 and another Vector2.
   * @param v - The Vector2 to calculate the distance to.
   * @returns The distance between the two vectors.
   */
  distanceTo(t) {
    const n = this.sub(t);
    return Math.hypot(n.x, n.y);
  }
  /**
   * Performs linear interpolation between this Vector2 and another Vector2.
   * @param v - The Vector2 to interpolate towards.
   * @param t - The interpolation factor (between 0 and 1).
   * @returns A new Vector2 instance representing the interpolated vector.
   */
  lerp(t, n) {
    const { x: e, y: i } = t.sub(this);
    return new r(this.x + e * n, this.y + i * n);
  }
  /**
   * Returns a string representation of this Vector2.
   * @returns A string representation of the vector in the format "(x, y)".
   */
  toString() {
    return `(${this.x}, ${this.y})`;
  }
}
export {
  N as DEG_TO_RAD,
  b as RAD_TO_DEG,
  r as Vector2,
  y as angleDifference,
  A as clamp,
  l as lerp,
  I as lerpAngle,
  T as perlinNoise,
  m as random,
  w as randomBool,
  D as randomChoice,
  f as randomInt,
  P as randomSign,
  p as shuffle,
  O as shuffleInPlace
};
